import { Area, PrstTxWarp } from '../../../type/common.interface';
import { getFuncLine } from '../../utils/get-func-line';

export function textTriangleInverted(prstTxWarp: PrstTxWarp, area: Area) {
    const bottomLine = (x: number) => {
        const point1 = { x: 0, y: 0 };
        const point2 = { x: area.width, y: 0 };

        return getFuncLine(
            x,
            point1,
            point2,
        );
    };

    const topLine = (x: number) => {
        if (x < area.width / 2) {
            const point1 = { x: 0, y: area.height / 2 };
            const point2 = { x: area.width / 2, y: area.height };

            return getFuncLine(
                x,
                point1,
                point2,
            );
        }

        const point1 = { x: area.width / 2, y: area.height };
        const point2 = { x: area.width, y: area.height / 2 };

        return getFuncLine(
            x,
            point1,
            point2,
        );
    };

    return [
        bottomLine,
        topLine,
    ];
}
